<ng-container *letVar="queryParams$ | async as params">
    <login-background>
        <ng-container title>{{
            params.emailExists === "true"
                ? "User already exists. Sign in to your account."
                : params.staff === "false"
                ? "Welcome Home"
                : "Sign in to your account."
        }}</ng-container>

        <app-email-form></app-email-form>

        <ng-container *ngIf="params.staff === 'false'">
            <div class="or-border">
                <span class="or-span">or</span>
            </div>
            <app-social-sign-in-block></app-social-sign-in-block>
        </ng-container>
    </login-background>
</ng-container>
